var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Signin flex flex-1 col-center"},[_vm._m(0),_c('TheLogin',{attrs:{"disabled":_vm.isLoading,"devLogin":_vm.devLogin},on:{"onLogin":_vm.handleSignin}}),_c('Notification',{attrs:{"group":"global","position":"bottom left"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Logo"},[_c('img',{attrs:{"src":require("@/assets/images/logos/qualitas-logo.svg")}})])
}]

export { render, staticRenderFns }